import { addDays, format, isValid, parse } from "date-fns";

import { RangeSliderPercentValueMapItem } from "@whoosh/design-system/src/components/controls/RangeSlider/types";

import { generateTimes } from "./generateTimes";

const parseSliderTime = (timeString: string) => {
  const formats = ["HH:mm:ss", "HH:mm"];

  for (const timeFormat of formats) {
    const parsedTime = parse(timeString, timeFormat, new Date());

    if (isValid(parsedTime)) {
      return parsedTime;
    }
  }

  return null;
};

export const formatSliderTimeLabel = (timeString: string) => {
  const parsedTime = parseSliderTime(timeString);
  return parsedTime ? format(parsedTime, "h aaa") : null;
};

export const normalizeSliderTimeValue = (
  timeString: string | null | undefined
) => {
  if (!timeString) {
    return undefined;
  }

  const parsedTime = parseSliderTime(timeString);
  return parsedTime ? format(parsedTime, "HH:mm:ss") : undefined;
};

export const getSliderOptions = (
  startTimeString?: string | null,
  endTimeString?: string | null
): RangeSliderPercentValueMapItem[] => {
  if (!startTimeString || !endTimeString) {
    return [];
  }
  const startTime = parseSliderTime(startTimeString);
  const parsedEndTime = parseSliderTime(endTimeString);

  if (!startTime || !parsedEndTime) {
    return [];
  }

  if (parsedEndTime.getTime() === startTime.getTime()) {
    return [
      {
        value: format(startTime, "HH:mm:ss"),
        label: format(startTime, "h aaa"),
        percentage: 0,
      },
    ];
  }

  const endTime =
    parsedEndTime <= startTime ? addDays(parsedEndTime, 1) : parsedEndTime;
  const times = generateTimes(startTime, endTime);
  return times.map((t, i) => ({
    value: format(t, "HH:mm:ss"),
    label: format(t, "h aaa"),
    percentage: i ? (i / (times.length - 1)) * 100 : 0,
  }));
};
